import React from "react";
import { Link } from "react-router-dom";

export const AccountDeletion = () => {
  return (
    <div className="cc-legal-page">
      <div className="container cc-legal-container">
        <img alt="crewcoinlogo" className="crewcoinMd2" src={'../img/crewcoinlogo.png'} />
        <h2>Crew Coin Account &amp; Data Deletion</h2>
        <p>
          This page explains how Crew Coin users can request deletion of their account and associated data.
        </p>

        <h3>How to request deletion</h3>
        <ul>
          <li>Email <strong>admin@crew-coin.com</strong></li>
          <li>Use subject line: <strong>Delete My Crew Coin Account</strong></li>
          <li>Include the email tied to your account and your organization/portal ID</li>
        </ul>

        <h3>What will be deleted</h3>
        <ul>
          <li>Account profile information</li>
          <li>User wallet/balance data</li>
          <li>Transaction and purchase history associated with the account</li>
          <li>Device push token data associated with the account</li>
        </ul>

        <h3>What may be retained</h3>
        <p>
          Limited records may be retained for legal compliance, security, fraud prevention, or audit obligations for up to 90 days.
        </p>

        <h3>Timeline</h3>
        <ul>
          <li>Request acknowledgment: within 3 business days</li>
          <li>Deletion completion: typically within 30 days</li>
        </ul>

        <p>
          Questions? Contact <strong>admin@crew-coin.com</strong>
        </p>

        <Link to="/" className="btn btn-custom2">Back to Crew Coin</Link>
      </div>
    </div>
  );
};
